const INITIAL_STATE = {
  targetLatency: 500,
  catchUpRate: 0.08,
  playbackRate: '',
  bufferSize: '',
  currentLatency: '',
  zappingTime: '',
  header: 'HESP',
  usecase: 'HESP',
  region: 'NA',
  timezoneName: 'America/New_York',
  playerVisible: true,
  zapElementVisible: true,
  latencySliderVisible: true,
  catchUpRateSliderVisible: false,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SET_PLAYER01_PARAMETERS':
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
